<template>
  <div id="mallHeader">
    <div class="center">
      <div class="logo">
        <p v-if="showSearch">积分商城</p>
        <p v-else>{{ $route.query.name || '' }}</p>
      </div>
      <div class="search" v-if="showSearch">
        <input type="text" v-model="searchKey" placeholder="输入商品名称进行搜索" @keydown.enter="search"/>
        <button class="but" @click="search">
          搜索
        </button>
      </div>
      <div v-if="jifen !== null" style="color: #333333;font-size: 16px;font-weight: 500;cursor: context-menu;">
        可用积分：{{ jifen }}分
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showSearch: {
      type: Boolean,
      default: () => null
    },
    jifen: {
      type: Number,
      default: () => null
    }
  },
  data () {
    return {
      searchKey: null
    }
  },
  mounted() {
    this.searchKey = this.$route.query.name
  },
  methods: {
    search () {
      this.$emit('search', this.searchKey)
    }
  }
}
</script>
<style lang="less" scoped>
#mallHeader {
  width: 100%;
}
.center {
  width: 1200px;
  height: 80px;
  line-height: 80px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  border-bottom: 2px solid #e6e6e6;
}
.logo{
  font-size: 30px;
  cursor: context-menu;
  p {
    color: #333333;
  }
}
.search {
  display: flex;
  align-items: center;

  input {
    width: 360px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid silver;
    border-radius: 4px 0px 0px 4px;
    outline: none;
    padding-left: 13px;

    &::placeholder {
      font-size: 12px;
      font-family: PingFang SC;
      color: #999;
    }
  }
  .but {
    height: 40px;
    border: 2px solid;
    font-size: 14px;
    border-radius: 0px 4px 4px 0px;
    width: 85px;
    background: #165dff;
    border: 1px solid #165dff;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
